<template>
  <ol class="breadcrumb" v-if="breadcrumbs.length">
    <li class="breadcrumb-item" v-for="(crumb, i) in breadcrumbs" :key="crumb.resolvedTitle">
      <span v-if="i === breadcrumbs.length - 1">{{crumb.resolvedTitle}}</span>
      <router-link v-else active-class="active" :to="getRouterLinkTo(crumb)">
        {{crumb.resolvedTitle}}
      </router-link>
    </li>
  </ol>
</template>

<script>
  import assoc from 'ramda/src/assoc'
  import map from 'ramda/src/map'
  import addIndex from 'ramda/src/addIndex'
  import filter from 'ramda/src/filter'
  import flatten from 'ramda/src/flatten'
  import pipe from 'ramda/src/pipe'

  function getBreadcrumbsWithPath(route) {
    const breadcrumbs = route.meta.breadcrumbs
    breadcrumbs.forEach(crumb => {
      crumb.path = route.path
    })
    return breadcrumbs
  }

  export default {
    asyncComputed: {
      breadcrumbs: {
        get() {
          const routes = this.$route.matched
          const breadcrumbsRoutes = filter(route => route.meta && route.meta.breadcrumbs)(routes)

          const breadcrumbs = pipe(
            map(getBreadcrumbsWithPath),
            flatten
          )(breadcrumbsRoutes)

          const getTitle = (crumb) => (crumb.title instanceof Function) ? crumb.title(this.$route) : crumb.title
          const promises = map(getTitle)(breadcrumbs)
          return Promise.all(promises)
            .then((titles) => {
              const mapIndexed = addIndex(map)
              const mapTitle = (crumb, key) => assoc('resolvedTitle', titles[key], crumb)
              return mapIndexed(mapTitle)(breadcrumbs)
            })
        },
        default: () => []
      }
    },

    methods: {
      getRouterLinkTo(crumb) {
        if (crumb.pathName) return {name: crumb.pathName}
        if (crumb.pathToFunction) {
          return crumb.pathToFunction(this.$route)
        }

        return {path: crumb.path}
      }
    }
  }
</script>
